import { EXCEL_FUNCTIONS } from './data/functionsData';
import { MR_EXCEL_SHORTCUTS } from './data/shortcutsLibrary';

const SITE_URL = 'https://mrexcelsrilanka.com';
const SITE_NAME = 'Mr Excel Sri Lanka';
const DEFAULT_DESCRIPTION =
  'Practical Excel training, workplace learning, function explanations, keyboard shortcuts and skill tests for teams and professionals in Sri Lanka.';

const PAGE_SEO = {
  home: {
    title: 'Mr Excel Sri Lanka | Corporate Excel Training & Resources',
    description: DEFAULT_DESCRIPTION,
    path: '/'
  },
  training: {
    title: 'Corporate Excel Training in Sri Lanka | Mr Excel Sri Lanka',
    description:
      'Department-focused Excel training for reporting, dashboards, automation and workplace productivity across Sri Lankan teams.',
    path: '/#/training'
  },
  functions: {
    title: 'Excel Functions Library | Mr Excel Sri Lanka',
    description:
      'Browse practical Excel function explanations, syntax, examples and workplace use cases for finance, reporting and analysis.',
    path: '/#/functions'
  },
  shortcuts: {
    title: 'Excel Keyboard Shortcuts | Mr Excel Sri Lanka',
    description:
      'Learn Excel keyboard shortcuts for faster navigation, formatting, formulas, tables, charts and daily spreadsheet work.',
    path: '/#/shortcuts'
  },
  'skill-test': {
    title: 'Excel Skill Test | Mr Excel Sri Lanka',
    description:
      'Test your Excel skills across shortcuts, functions, pivot tables, charts, Power Query, VBA and practical workplace tasks.',
    path: '/#/skill-test'
  },
  contact: {
    title: 'Contact Mr Excel Sri Lanka | Corporate Excel Training',
    description:
      'Contact Mr Excel Sri Lanka to plan onsite or online Excel training, dashboards, reporting support and workplace learning.',
    path: '/#/contact'
  }
};

function getMetaByName(name) {
  let node = document.querySelector(`meta[name="${name}"]`);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute('name', name);
    document.head.appendChild(node);
  }
  return node;
}

function getMetaByProperty(property) {
  let node = document.querySelector(`meta[property="${property}"]`);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute('property', property);
    document.head.appendChild(node);
  }
  return node;
}

function getLink(rel) {
  let node = document.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement('link');
    node.setAttribute('rel', rel);
    document.head.appendChild(node);
  }
  return node;
}

function getPageSeo(route, subRoute) {
  if (route === 'functions-detail') {
    const item = EXCEL_FUNCTIONS.find((func) => func.slug === subRoute);
    if (item) {
      return {
        title: `${item.name} Excel Function | Syntax, Example & Use`,
        description: `${item.name}: ${item.description} Learn the syntax ${item.syntax} with a practical Excel example.`,
        path: `/#/functions/${item.slug}`
      };
    }
  }

  if (route === 'shortcuts-detail') {
    const item = MR_EXCEL_SHORTCUTS.find((shortcut) => shortcut.slug === subRoute);
    if (item) {
      const keys = [item.windows, item.mac].filter(Boolean).join(' / ');
      return {
        title: `${item.title} Excel Shortcut | Mr Excel Sri Lanka`,
        description: `Use ${keys || 'this shortcut'} to ${item.title.toLowerCase()} in Excel. Learn practical keyboard shortcuts for faster spreadsheet work.`,
        path: `/#/shortcuts/${item.slug}`
      };
    }
  }

  return PAGE_SEO[route] || PAGE_SEO.home;
}

export function applyPageSeo(route, subRoute = '') {
  const seo = getPageSeo(route, subRoute);
  const url = `${SITE_URL}${seo.path}`;
  const image = `${SITE_URL}/excel-icon.png`;

  document.title = seo.title;
  getMetaByName('description').setAttribute('content', seo.description);
  getMetaByName('robots').setAttribute('content', route === 'admin' ? 'noindex,nofollow' : 'index,follow');

  getLink('canonical').setAttribute('href', url);

  getMetaByProperty('og:title').setAttribute('content', seo.title);
  getMetaByProperty('og:description').setAttribute('content', seo.description);
  getMetaByProperty('og:url').setAttribute('content', url);
  getMetaByProperty('og:type').setAttribute('content', 'website');
  getMetaByProperty('og:site_name').setAttribute('content', SITE_NAME);
  getMetaByProperty('og:image').setAttribute('content', image);

  getMetaByName('twitter:card').setAttribute('content', 'summary_large_image');
  getMetaByName('twitter:title').setAttribute('content', seo.title);
  getMetaByName('twitter:description').setAttribute('content', seo.description);
  getMetaByName('twitter:image').setAttribute('content', image);
}
